import { Injectable } from '@angular/core'
import { PlanFileDao } from '../services/dao/plan-file.dao'
import {
  CreateFileArticlesParams,
  CreateFilePieceListsResult,
  CreateFilesParamsV2,
  CreateFilesResultV2,
} from '../../generated/efp-api/models'

@Injectable({
  providedIn: 'root',
})
export class PlanFileRepository {
  constructor(private readonly planFileDao: PlanFileDao) {}

  public async createPlanResult(
    planId: number,
    body: CreateFilesParamsV2
  ): Promise<CreateFilesResultV2> {
    return await this.planFileDao.createPlanFiles(planId, body)
  }

  public async createPlanPieceList(
    planId: number,
    body: CreateFileArticlesParams
  ): Promise<CreateFilePieceListsResult> {
    return await this.planFileDao.createPlanPieceLists(planId, body)
  }
}
